import Timeline from './Timeline';
export default Timeline;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/timeline/index.js
// module id = 832
// module chunks = 0